// extracted by mini-css-extract-plugin
module.exports = {"main-cont":"main_main-cont_28NIt","container":"main_container_3EUVG","footer-bottom":"main_footer-bottom_6PHz6"};